import { Fragment } from 'react/jsx-runtime';

import { useGetRecentActivity } from '../hooks';

import { RecentActivityError } from './RecentActivityError';
import { RecentActivityListLoading } from './RecentActivityListLoading';
import { RecentActivityTableRow } from './RecentActivityTableRow';
import { RecentActivityStatus } from './RecentActivityStatus';

const data = [
  {
    date: '2023-08-01T12:00:00Z',
    description: 'Dreamworld Entry',
    type: 'spend',
    credits: '-28',
    balance: '42',
  },
  {
    date: '2023-08-01T12:00:00Z',
    description: 'Login Bonus',
    type: 'grant',
    credits: '+15',
    balance: '70',
  },
  {
    date: '2023-08-01T12:00:00Z',
    description: 'Login Bonus',
    type: 'grant',
    credits: '+15',
    balance: '70',
  },
  {
    date: '2023-08-01T12:00:00Z',
    description: 'Login Bonus',
    type: 'grant',
    credits: '+15',
    balance: '70',
  },
  {
    date: '2023-08-01T12:00:00Z',
    description: 'Login Bonus',
    type: 'grant',
    credits: '+15',
    balance: '70',
  },
];

export const RecentActivityList = () => {
  const recentActivityQuery = useGetRecentActivity();

  if (recentActivityQuery.isLoading) return <RecentActivityListLoading />;

  if (!recentActivityQuery.data || !Array.isArray(recentActivityQuery.data))
    return <RecentActivityStatus />;

  if (recentActivityQuery.isError)
    return <RecentActivityError refetch={recentActivityQuery.refetch} />;

  return (
    <Fragment>
      {recentActivityQuery.data &&
        recentActivityQuery.data.map((user, index) => {
          return <RecentActivityTableRow key={index} {...user} />;
        })}
    </Fragment>
  );
};
